import { IExportRecipientsParams } from '@app/models/interfaces';
import Api from '@app/services/api';
import { useExportDownload } from '@app/services/hooks/useExportDownload';

export const useExportRecipientsQuery = () => {
  return useExportDownload<IExportRecipientsParams>({
    downloadPrefix: 'recipients',
    getFilePath: (filename) => `/dictionaries/recipients/exported/${filename}`,
    mutationFn: (params) => Api.dictionaries.exportRecipients(params),
  });
};
